// extracted by mini-css-extract-plugin
export default {"exchange":"Middle_exchange__VAcqC","heading":"Middle_heading__A12Am","exchangeLogo":"Middle_exchangeLogo__mxjo1","exchangeContainer":"Middle_exchangeContainer__QCbjo"};